import { apiClient } from "@/lib/api";
import type { LocalityRef } from "@/types/localities";

/**
 * Prefix search over the global locality reference (Sprint 228, TASK-5167).
 * GET /api/v1/localities/?q=<prefix>&limit=<n>
 *
 * The server does the folding (`ё`/`е`, case) and returns active localities
 * only, ordered by name then district. A `q` shorter than two characters is
 * answered with `[]`, so callers do not need to guard it — they still do, to
 * save the round-trip.
 *
 * The envelope is a plain array (verified live on dev, 2026-10-30), not a
 * paginated object. The unwrap lives here, in one place, so a later switch to
 * pagination changes one line.
 */
export async function searchLocalities(
  q: string,
  limit = 20,
): Promise<LocalityRef[]> {
  const response = await apiClient.get<
    LocalityRef[] | { results: LocalityRef[] }
  >("/v1/localities/", { params: { q, limit } });
  const data = response.data;
  return Array.isArray(data) ? data : (data?.results ?? []);
}
